import { gql } from '@apollo/client';

export type { GetReferralDashboardData as IGetReferralDashboardData } from './__generated__/GetReferralDashboardData';

export const GET_REFERRALS_DATA = gql`
  query GetReferralDashboardData {
    organization {
      referralUrl
      partnershipType
      inPartnerBuyerLeadPilot
    }
  }
`;
